import { Icon, IconProps } from '@chakra-ui/react'
import { FC } from 'react'

export const FiveStars: FC<IconProps> = (props) => {
  return (
    <Icon width={95} height={18} viewBox="0 0 95 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.858 0l2.343 5.633 6.081.488-4.633 3.969 1.416 5.934-5.207-3.18-5.207 3.18 1.416-5.934L.434 6.12l6.081-.487L8.858 0zM28.178 0l2.343 5.633 6.082.488-4.634 3.969 1.416 5.934-5.207-3.18-5.206 3.18 1.415-5.934-4.633-3.97 6.081-.487L28.178 0zM47.499 0l2.343 5.633 6.081.488-4.633 3.969 1.415 5.934-5.206-3.18-5.207 3.18 1.416-5.934-4.634-3.97 6.082-.487L47.499 0zM66.819 0l2.343 5.633 6.081.488-4.633 3.969 1.416 5.934-5.207-3.18-5.207 3.18 1.416-5.934-4.633-3.97 6.081-.487L66.819 0zM86.143 0l2.343 5.633 6.082.488-4.634 3.969 1.416 5.934-5.207-3.18-5.206 3.18 1.415-5.934-4.633-3.97 6.081-.487L86.143 0z"
        fill="#FFE165"
      />
    </Icon>
  )
}
